/* ════════════════════════════════════════════════════════
   keke-main.js
   Folder: assets/
   Purpose: All JavaScript for the Keke Pavlova homepage.
   Loaded via {{ 'keke-main.js' | asset_url | script_tag }}
   before </body> in layout/theme.liquid
════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── NAV SCROLL BEHAVIOUR ──
  // Switches nav from transparent (over hero) to white (once scrolled)
  function initNav() {
    var nav = document.getElementById('keke-main-nav');
    if (!nav) return;

    var hero = document.querySelector('.keke-hero');
    var heroHeight = hero ? hero.offsetHeight : 400;

    window.addEventListener('scroll', function() {
      // Toggle .scrolled class once user has scrolled 15% of the hero height
      nav.classList.toggle('scrolled', window.scrollY > heroHeight * 0.15);
    }, { passive: true });
  }

  // ── SCROLL FADE-UP ANIMATIONS ──
  // Watches for .keke-fade-up elements entering the viewport,
  // adds .visible to trigger the CSS transition
  function initFadeUp() {
    var elements = document.querySelectorAll('.keke-fade-up');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // Stop watching once visible
        }
      });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
// Hero elements visible on load — trigger immediately
document.querySelectorAll('.hero .fade-up').forEach(function(el) {
  setTimeout(function() {
    el.classList.add('visible');
  }, 100);
});
    elements.forEach(function(el) { observer.observe(el); });
  }

  // ── BOX IMAGE GALLERY SWAP ──
  // Replaces the main image when a thumbnail is clicked
  // Uses event delegation — one listener on the whole section,
  // not one per thumbnail (better performance, Theme Editor safe)
  function initBoxGallery() {
    var boxSection = document.querySelector('.keke-boxes-section');
    if (!boxSection) return;

    boxSection.addEventListener('click', function(e) {
      var thumb = e.target.closest('.keke-box-thumb');
      if (!thumb) return;

      // Find the main image ID stored in data-target on the thumb
      var targetId = thumb.getAttribute('data-target');
      var newSrc   = thumb.getAttribute('data-src');
      if (!targetId || !newSrc) return;

      var mainImg = document.getElementById(targetId);
      if (!mainImg) return;

      // Fade out → swap src → fade in
      mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = newSrc;
        mainImg.style.opacity = '1';
      }, 150);

      // Update active state on thumbs within the same gallery column
      var col = thumb.closest('.keke-box-images-col');
      if (col) {
        col.querySelectorAll('.keke-box-thumb').forEach(function(t) {
          t.classList.remove('active');
        });
      }
      thumb.classList.add('active');
    });
  }

  // ── TESTIMONIAL CARD ANIMATIONS ──
  // Triggers the staggered slide-up animation when cards enter viewport
  function initTestiCards() {
    var cards = document.querySelectorAll('.keke-testi-card');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    cards.forEach(function(el) { observer.observe(el); });
  }

  // ── SHOPIFY SECTION EVENTS ──
  // Required for Theme Editor live preview compatibility.
  // When a merchant edits a section in the Theme Editor,
  // Shopify re-renders that section and fires these events.
  // Re-initialising our JS ensures animations and galleries
  // work correctly in the editor after a section update.
  document.addEventListener('shopify:section:load', function(e) {
    initNav();
    initFadeUp();
    initBoxGallery();
    initTestiCards();
  });

  // ── INIT ON DOM READY ──
  document.addEventListener('DOMContentLoaded', function() {
    initNav();
    initFadeUp();
    initBoxGallery();
    initTestiCards();
  });

})();